import ViewPlanHarmForm from "../../components/views/planHarm/wp/planHarmForm/ph1/ViewPlanHarmForm.jsx";
import {
    ViewPlanHarmGantt
} from "../../components/views/planHarm/lib/components/planHarmGantt/pages/ViewPlanHarmGantt.jsx";

export const planHarmRoutes = [

    {
        path: `/wp/harm/:tryb/:rejestrId`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewPlanHarmForm/>,
        mode: `pass`,
    },

    {
        path: `/wp/harm/gantt/:rejestrId`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewPlanHarmGantt />,
        mode: `pass`,
    },
]
